export function Background() {
    return (
        <div className="hillsBackground"></div>

    )
}